<form id="dynamicForm-form" class="dynamic-form" [formGroup]="form">
  <div id="dynamicForm-form-div" class="container-fluid">
    <div class="row" id="dynamicForm-form-div2">
      <ng-container id="dynamicForm-form-ngContain" *ngFor="let field of fields">
        <div class="col-6" id="dynamicForm-form-div3" *ngIf="field.type != 23 && field.type != 1 && field.type != 22">
          <ng-container id="dynamicForm-form-ngContain2" dynamicField [field]="field" [group]="form"> </ng-container>
          <span id="dynamicForm-form-span" class="space"></span>
        </div>
        <div
          id="dynamicForm-form-div4"
          class="col-12"
          *ngIf="field.type === 23 || field.type === 1 || field.type === 22"
        >
          <ng-container id="dynamicForm-form-ngContain3" dynamicField [field]="field" [group]="form"> </ng-container>
          <span id="dynamicForm-form-span2" class="space"></span>
        </div>
      </ng-container>
    </div>
  </div>
</form>
